import React from "react";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../components/FluentUI/Fluent-Dialog2";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";

export const AutoPopulateDialogStatus = ({ open, OnCancel, OnSave }) => {
  return (
    <FluentDialog2 open={open}>
      <div className="task-type-dialog-title">
        <p>{`Auto-populate the form`}</p>
        <p onClick={OnCancel}>
          <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
        </p>
      </div>
      <div className="task-type-dialog-content">
        <p>{`There is currently a request in progress to auto-populate transaction data. 
        Please confirm you would like to create a new auto-populate request.`}</p>
      </div>
      <div className="task-type-dialog-footer">
        <FluentButton
          onClick={OnCancel}
          text={"Cancel"}
          backgroundColor={"#0F6CBD"}
        />
        <FluentButton
          onClick={OnSave}
          appearance="primary"
          text="Create New Request"
          backgroundColor={"#0F6CBD"}
        />
      </div>
    </FluentDialog2>
  );
};

AutoPopulateDialogStatus.propTypes = {
  open: PropTypes.bool.isRequired,
  OnCancel: PropTypes.func.isRequired,
  OnSave: PropTypes.func.isRequired,
};
